<template>
    <kgr-generic-select
        ref="dropdown"
        display="display"
        :value="value"
        :label="label"
        :options="sepaDebits"
        :loading="loading"
        :inline="inline"
        @post-input="onInput"
    />
</template>

<script>
import GenericSelect from './GenericSelect.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-generic-select': GenericSelect,
    },
    props: {
        memberId: {
            type: Number,
            required: true,
        },
        value: {
            type: [String, Object],
            required: false,
            default: null
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            sepaDebits: [],
        }
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('club.memberSepaDebits');
        },
    },
    created() {
        this.loadSepaDebits();
    },
    methods: {
        loadSepaDebits() {
            this.loading = true;
            axios
                .get('/club/members/' + this.memberId + '/member-sepa-debits?excludeArchived=true')
                .then(response => {
                    this.sepaDebits = response.data.data.map((data) => {
                        return {
                            id:data.id,
                            memberBankAccount: data.memberBankAccount,
                            mandateReference: data.mandateReference,
                            isCurrentDefault: data.isCurrentDefault,
                            display: this.getItemText(data)
                        }
                    });
                    let selected = null;

                    if (typeof this.value === 'string') {
                        selected = this.sepaDebits.find(s => s.id === this.value);
                    }

                    if (!selected) {
                        selected = this.sepaDebits.find(s => s.isCurrentDefault);
                    }

                    if (selected) {
                        this.$emit('input', selected);
                        this.$nextTick(() => {
                            this.$emit('post-input', selected);
                        });
                    }

                    this.loading = false;
                });
        },
        getItemText(item) {
            return item.memberBankAccount.owner + ' (' + item.memberBankAccount.iban + ' ' + item.memberBankAccount.bic + ') ' + item.mandateReference.number;
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        }
    }
}
</script>
